module.exports = __webpack_public_path__ + "static/media/icon_anunciate_paquetes-medida.4bd428da.svg";